import * as React from "react";
import PropTypes from "prop-types";
import styled, { useTheme } from "styled-components";
import BaseLink from "./base-link";
import { Icon } from "../../../../components/icon/v2";
import { defaultFontStack } from "../../../../styles/typography/v2";

const Root = styled(BaseLink)(defaultFontStack, (props) => {
  const { theme, $hasBorder, $color, $textColor } = props;

  return {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 10,
    color: $textColor,
    border: $hasBorder ? `2px solid ${theme.colors.day}` : undefined,
    backgroundColor: $color,
    padding: `10px 15px`,
    borderRadius: 40,
    fontSize: 16,
    textDecoration: "none",
    width: "fit-content",
  };
});

function CallToAction(props) {
  const theme = useTheme();

  const {
    id,
    className,
    children,
    url,
    color = theme.colors.deep,
    textColor = theme.colors.day,
    border = false,
    external = false,
    download = false,
    arrow = true,
    wistia,
  } = props;

  return (
    <Root
      id={id}
      data-component-name="call-to-action"
      className={className}
      url={url}
      $color={color}
      $textColor={textColor}
      external={external}
      download={download}
      $hasBorder={border}
      wistia={wistia}
    >
      {children}
      {arrow ? (
        <Icon name="arrow-right" type="vorne" height={20} width={40} />
      ) : null}
    </Root>
  );
}

CallToAction.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  url: PropTypes.string,
  external: PropTypes.bool,
  download: PropTypes.bool,
  border: PropTypes.bool,
  arrow: PropTypes.bool,
};

export default CallToAction;
